import { render, staticRenderFns } from "./StadiumBoostUpdateForm.vue?vue&type=template&id=2ce1a423&"
import script from "./StadiumBoostUpdateForm.vue?vue&type=script&lang=js&"
export * from "./StadiumBoostUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./StadiumBoostUpdateForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce1a423')) {
      api.createRecord('2ce1a423', component.options)
    } else {
      api.reload('2ce1a423', component.options)
    }
    module.hot.accept("./StadiumBoostUpdateForm.vue?vue&type=template&id=2ce1a423&", function () {
      api.rerender('2ce1a423', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumBoostUpdateForm.vue"
export default component.exports